import {
  LocationDictionaryItem,
} from '@dapi/sdk';

export const CHARLES_DE_GAULLE: LocationDictionaryItem = {
  type: 'airport',
  airportName: 'CHARLES DE GAULLE',
  cityCode: 'PAR',
  countryCode: 'FR',
  timeZone: 'UTC+0200'
};

export const JOHN_F_KENNEDY_INTL: LocationDictionaryItem = {
  type: 'airport',
  airportName: 'JOHN F KENNEDY INTL',
  cityCode: 'NYC',
  stateCode: 'NY',
  countryCode: 'US',
  timeZone: 'UTC-0400'
};

export const COTE_D_AZUR: LocationDictionaryItem = {
  type: 'airport',
  airportName: 'COTE D AZUR',
  cityCode: 'NCE',
  cityName: 'NICE',
  countryCode: 'FR',
  timeZone: 'UTC+0200'
};
